import { SET_PAGE_TITLE, SET_PAGE_DESCRIPTION, SET_PAGE_KEYWORDS, OPEN_SIDEBAR, CLOSE_SIDEBAR, SHOW_PUBLIC_ELEMS, HIDE_PUBLIC_ELEMS, SET_AD_AREA} from '../mutation-types'
import router from '../../router'
import Contact from '../../resources/contact'


const state = {
  title: null,
  description: null,
  keywords: null,
  sidebarOpen: true,
  publicNav: true,
  adArea: '',
}

const getters = {}

const actions = {
  contactus(context, payload) {
    Contact.save(payload.form).then((res) => {
      Toast.success('Your message was sent successfully.')
    }, (res) => {
      Toast.error('Failed to send contact form')
    })
  },
}

const mutations = {
  [SET_PAGE_TITLE] (state, payload) {
    state.title = payload.title;
    document.title = `CLEX | ${payload.title}`;
    $('meta[name=title]').remove();
    if (payload.title) {
      $('head').append('<meta name="title" content="' + payload.title + '">');
    }
  },

  [SET_PAGE_DESCRIPTION](state, payload) {
    state.description = payload.description;
    $('meta[name=description]').remove();
    if (payload.description) {
      $('head').append('<meta name="description" content="' + payload.description + '">');
    }
  },

  [SET_PAGE_KEYWORDS](state, payload) {
    state.keywords = payload.keywords;
    $('meta[name=keywords]').remove();
    if (payload.keywords) {
      $('head').append('<meta name="keywords" content="' + payload.keywords + '">');
    }
  },

  [OPEN_SIDEBAR] (state, payload) {
    state.sidebarOpen = true;
    $('body').removeClass('be-nosidebar-left');
  },

  [CLOSE_SIDEBAR] (state, payload) {
    state.sidebarOpen = false;
    $('body').addClass('be-nosidebar-left');
  },
  [SHOW_PUBLIC_ELEMS](state, payload) {
    state.publicNav = true;
  },
  [HIDE_PUBLIC_ELEMS](state, payload) {
    state.publicNav = false;
  },
  [SET_AD_AREA](state, payload) {
    state.adArea = payload.adArea;
  },
}



export default {
  state,
  getters,
  actions,
  mutations
}





// WEBPACK FOOTER //
// ./src/store/modules/page.js